export function createFlash({ key = null, message, ttl = 10, stack = true, withLink = false }) {
  document.dispatchEvent(
    new CustomEvent("flash:create", { detail: { key, message, ttl, stack, withLink } })
  );
}
